import script from "./AdminOnboardingDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOnboardingDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminOnboardingDashboardView.vue?vue&type=style&index=0&id=26939702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26939702"]])

export default __exports__